const whatToSet = function (viewValue) {
	let phoneNumber = ('' + viewValue).replace(/\D/g, '');
	return phoneNumber;
};

export const TelephoneNumberInput = () => {
	'ngInject';
	return {
		restrict: 'A',
		require: '?ngModel',
		link:  (scope, element, attrs, ctrl) => {
			if (!ctrl) return;

			/**
			 * mod by user(V to M)
			 */
			ctrl.$parsers.push(whatToSet);

			/**
			 * mod by prog(M to V)
			 */
			ctrl.$formatters.push(function (phoneNumber) {
				var pattern = /^(\+36|36|06|)?(20|30|31|70|1)(\d{3})(\d{4})$/;
				if ( phoneNumber && pattern.test(phoneNumber)) {
					return phoneNumber.trim().replace(pattern, '+36 $2 $3 $4');
				} else {
					let phone = ('' + phoneNumber).replace(/\D/g, '');
					return phone;
				}
			});

			/**
			 * Mezőbe más érték mint a modellbe
			 */
			element.bind('blur', function () {
				element.val(function () {
					var pattern = /^(\+36|36|06|)?(20|30|31|70|1)(\d{3})(\d{4})$/;
					if ( pattern.test(ctrl.$modelValue)) {
						return ctrl.$modelValue.trim().replace(pattern, '+36 $2 $3 $4');
					} else {
						let phoneNumber = ('' + ctrl.$modelValue).replace(/\D/g, '');
						if (phoneNumber != '') {
							return phoneNumber;
						} else {
							ctrl.$setValidity('required', false);
							ctrl.$viewValue = '';
							return '';
						}
					}
				});
			});

			element.bind('focus', function () {
				element.val(ctrl.$modelValue);
			});
		}
	};
};
